import { memo, ReactNode, Ref } from 'react'
import cn from 'classnames'

import { Text } from '../Text'
import { Title } from '../Title'

import s from './styles.module.less'
import cs from 'src/common.module.less'

interface IProps {
  children: ReactNode
  action?: ReactNode
  className?: string
  description?: string
  innerRef?: Ref<HTMLDivElement>
  title?: string
}

const Widget = memo(function Widget({ className, title, action, description, children, innerRef }: IProps) {
  const hasHeader = Boolean(title || description || action)

  return (
    <div ref={innerRef} className={cn(s.container, cs.shadowOne, className)}>
      {hasHeader && (
        <div className={s.header}>
          <div className={s.title}>
            <Title size="h2">{title}</Title>
            {description && (
              <Text block color="secondary">
                {description}
              </Text>
            )}
          </div>

          {action && <div className={s.action}>{action}</div>}
        </div>
      )}
      {children}
    </div>
  )
})

export default Widget
